import { render, staticRenderFns } from "./subcategoria2_listado.vue?vue&type=template&id=14e87d01"
import script from "./subcategoria2_listado.vue?vue&type=script&lang=js"
export * from "./subcategoria2_listado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports